export default {
    'loading': 'loading',
    'trust': '【{name} entrust】',
};
